// extracted by css-extract-rspack-plugin
export default {"graphic":"SmartApplyPartnerLogos_graphic__z-fM+","logoSlot":"SmartApplyPartnerLogos_logoSlot__0c-DK","logo":"SmartApplyPartnerLogos_logo__p11Do"};